module.exports = __webpack_public_path__ + "static/media/Chicken4.c89a4843.png";